<template>
  <div id="overlay" v-if="visible">
    <div id="loader" class="mx-auto">
      <circle-load size="75px"></circle-load>
    </div>
  </div>
</template>
<style>
@import "../styles/components/Overlay.scss";
</style>
<script>
import { mapState } from 'vuex';
import CircleLoad from "vue-loading-spinner/src/components/Circle";

export default {
  components: {
    CircleLoad
  },
  computed: mapState({
    visible: state => state.app.overlay
  })
}; //end export
</script>
